import { GridHeaders } from '@project-types/GridHeaders';
import { SkuDcReportGridData } from '@pages/reporting-pages/deliveries-sku-dc/types/SkuDcReportGridData';



export const headersObject: GridHeaders<SkuDcReportGridData> = [
	{ label: 'Stát', key: 'country', width: '1fr' },
	{ label: 'Depo', key: 'executionPlaceName', width: '1fr' },
	
	{ label: 'Total - Objem [hl]', key: 'total_volume', width: '1fr' },
	{ label: 'Total - Váha [t]', key: 'total_weight', width: '1fr' },
	{ label: 'Total - Počet objednávek', key: 'total_ordersCount', width: '1fr' },

	{ label: 'ON - Objem [hl]', key: 'on_volume', width: '1fr' },
	{ label: 'ON - Váha [t]', key: 'on_weight', width: '1fr' },
	{ label: 'ON - Počet objednávek', key: 'on_ordersCount', width: '1fr' },

	{ label: 'OFF - Objem [hl]', key: 'off_volume', width: '1fr' },
	{ label: 'OFF - Váha [t]', key: 'off_weight', width: '1fr' },
	{ label: 'OFF - Počet objednávek', key: 'off_ordersCount', width: '1fr' },
]